import { get, set } from 'lodash';

import { ENTITY_TYPE, FIELD_PATHS } from '@funnels/constants';
import {
  BrokerInterviewsGuarantorWithId,
  FormValuesPostProductSelect,
  PostProductSelectContract,
} from '@funnels/types';

import { INITIAL_BROKER_INTERVIEW_GUARANTOR } from './initialFormValues';

export function setBrokerInterviewsGuarantorInitialValues(formValues: FormValuesPostProductSelect) {
  const postProductSelects = get(formValues, FIELD_PATHS.POST_PRODUCT_SELECTS(), []) as PostProductSelectContract[];
  const brokerInterviewsGuarantor = get(
    formValues,
    FIELD_PATHS.BROKER_INTERVIEWS_GUARANTORS(),
    []
  ) as BrokerInterviewsGuarantorWithId[];
  const brokerInterviewsGuarantorToBeCreated: BrokerInterviewsGuarantorWithId[] = [];

  postProductSelects
    .filter(
      (pps) =>
        get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_ENTITY_TYPE(0)) ===
        ENTITY_TYPE.GUARANTOR_COMPLIANCE
    )
    .forEach((pps) => {
      const applicantId = get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_ENTITY_ID(0));

      const hasBrokerInterviewsGuarantor = brokerInterviewsGuarantor.some(
        (interview) =>
          get({ brokerInterviewsGuarantor: [interview] }, FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_APPLICANT_ID(0)) ===
          applicantId
      );
      //initialize
      if (!hasBrokerInterviewsGuarantor) {
        brokerInterviewsGuarantorToBeCreated.push(INITIAL_BROKER_INTERVIEW_GUARANTOR(applicantId));
      }
    });

  set(formValues, FIELD_PATHS.BROKER_INTERVIEWS_GUARANTORS(), [
    ...brokerInterviewsGuarantor,
    ...brokerInterviewsGuarantorToBeCreated,
  ]);
}
